import { transparentize } from "polished";
import styled from "styled-components";

import { Text } from "/component/base";

export const ButtonText = styled(Text)(({ theme }) => ({
  borderBottom: `solid 2px ${transparentize(0.7, theme.colors.brandPrimary)}`,
}));
